<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page="itemsPerPage"
    :server-items-length="serverItemsLength"
    :loading="loading"
    :search="localSearch"
    @update:options="handlePagination"
    loading-text="Loading..."
    height="550"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model.lazy="localSearch"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="Search"
          class="desktop"
        ></v-text-field>
        <v-spacer></v-spacer>

        <slot name="headerAction"></slot>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <slot name="actions" :item="item">
        <div
          v-show="$vuetify.breakpoint.smAndDown"
          :class="$vuetify.breakpoint.smOnly ? 'pa-2' : ''"
        >
          <v-btn
            outlined
            class="mr-2"
            :class="$vuetify.breakpoint.smOnly ? 'mb-2 pa-2' : ''"
            dark
            small
            color="light-blue darken-4"
            @click="onViewItem(item)"
          >
            view
          </v-btn>
          <v-btn
            v-if="!isAuditorRole"
            outlined
            dark
            color="red lighten-1"
            small
            @click="onDeleteItem(item)"
          >
            delete
          </v-btn>
        </div>

        <div v-show="$vuetify.breakpoint.mdAndUp">
          <v-icon class="mr-1" small @click="onViewItem(item)">
            mdi-eye
          </v-icon>
          <v-icon v-if="!isAuditorRole" small @click="onDeleteItem(item)"> mdi-delete </v-icon>
        </div>
      </slot>
      <slot name="download" :item="item"> </slot>
    </template>
  </v-data-table>
</template>

<script>

export default {
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    serverItemsLength: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: "",
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    title: {
      type: String,
      default: "Data Table",
    },
    actions: {
      type: Array,
      default: () => [],
    },
    isAuditorRole: {
     type: Boolean,
     default: false
    }
  },
  data() {
    return {
      localSearch: this.search,
    };
  },
  watch: {
    search(newVal) {
      this.localSearch = newVal;
    },
    localSearch(newVal) {
      this.$emit("update:search", newVal);
    },
  },

  methods: {
    handlePagination(options) {
      this.$emit("update:options", options);
    },

    onShowAdd() {
      this.$emit("show-add");
    },

    onViewItem(item) {
      this.$emit("on-view-item", item);
    },

    onDeleteItem(item) {
      this.$emit("on-delete-item", item);
    },
  },
};
</script>
